import React, { useEffect, useState } from "react";
import { Avatar, Typography, Badge, Button } from "antd";
import { FormattedMessage } from "react-intl";
import { getAgeByDate } from "../../../components/util/helpers";
import { assignEmployee } from "../../employeeDetails/employeeDetailsSlice";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

const { Title } = Typography;
const Header = (props) => {
  const { record, hide } = props;
  const [isOtherBranch, setIsOtherBranch] = useState(false);
  const assignLoading = useSelector(
    (state) => state.pendingActions["employeeDetails/assign"]
  );
  const letter = record && record.first_name ? record.first_name.charAt(0) : "";
  let location = useLocation();
  let history = useHistory();
  const dispatch = useDispatch();
  let { branchId } = useParams();
  useEffect(() => {
    let is_other = false;
    if (branchId) {
      const filtered = record.branch_active
        ? record.branch_active.filter((item) => item.branch_id === +branchId)[0]
        : null;
      if (filtered) {
        is_other = false;
      } else {
        is_other = true;
      }
    }
    setIsOtherBranch(is_other);
  }, [record, branchId]);

  const url = branchId
    ? `/branches/${branchId}/employees/${record.id}`
    : `/admin/employees/${record.id}`;

  const onAddEmployeeToBranch = async () => {
    const params = {
      branchId: branchId,
      employeeId: record.id,
    };
    const isAdmin = location.pathname.includes("admin");
    const action = await dispatch(assignEmployee(params));
    if (!action.error) {
      hide();
      const url = isAdmin
        ? "/admin/employees/" + record.id
        : "/branches/" + branchId + "/employees/" + record.id;
      history.push(url);
    }
  };
  const statusData = [
    {
      value: 1,
      name: <FormattedMessage id="app.forms.active" />,
      status: "success",
    },
    {
      value: 2,
      name: <FormattedMessage id="app.forms.not_active" />,
      status: "error",
    },
    {
      value: 3,
      name: <FormattedMessage id="app.forms.candidate" />,
      status: "processing",
    },
    {
      value: 4,
      name: <FormattedMessage id="app.forms.pre" />,
      status: "warning",
    },
  ];

  const status =
    record && record.status_id
      ? statusData[record.status_id - 1]["status"]
      : null;
  const statusName =
    record && record.status_id ? statusData[record.status_id - 1]["name"] : "";
  const employeeAge =
    record && record.birthday ? getAgeByDate(record.birthday) : null;
  const arr = [`${record.surename} ${record.first_name}`];
  if (employeeAge) {
    arr.push(employeeAge);
  }
  const name = record ? arr.join(", ") : "";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        alignItems: "flex-end",
      }}
    >
      <div className="header_container">
        {record && record.avatar_url ? (
          <Avatar className="avatar" src={record.avatar_url} />
        ) : (
          <Avatar
            className="avatar"
            style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
          >
            {letter}
          </Avatar>
        )}
        <div className="spacer" />
        <div className="header_details_container">
          <Link
            style={{ color: "inherit" }}
            to={{
              pathname: url,
            }}
          >
            <Title level={1}>{name}</Title>
          </Link>
          <Badge className="status_badge" status={status} text={statusName} />
        </div>
      </div>
      {isOtherBranch && (
        <Button
          type="primary"
          onClick={onAddEmployeeToBranch}
          loading={assignLoading}
        >
          <FormattedMessage id="app.forms.employee.add_employee_to_branch" />
        </Button>
      )}
    </div>
  );
};

export default Header;
